
export default {
  components: {},
  props: {
    locationLink: {
      type: String,
      default: "#"
    },
    locationImage: {
      type: String,
    },
    locationName: {
      type: String,
      default: 'Place Name'
    },
    locationArea: {
      type: String,
      default: ''
    },
    locationRatings: {
      type: Number,
      default: 0
    },
    locationCity: {
      type: String,
      default: 'City'
    },
    locationCategory: {
      type: String,
      default: 'Category'
    },
    locationBrief: {
      type: String,
      default: 'Description'
    },
    locationDistance: {
      type: Number,
      default: 0
    },
    postIdx: {
      type: Number,
      default: 0
    },
    attractionIdx: {
      type: Number,
      default: 0
    },
    isAttraction: {
      type: Boolean,
      default: false
    },
    attractions:{
      default: ''
    }
  },
  methods: {
    clickAttraction(index,ind,attractions,slug){
      if(attractions && attractions.length > 0){
        let data = {
          postIndex : index,
          attractionIndex: ind,
          allAttractions : attractions
        }
        this.$emit('blogIdSent', slug)
          localStorage.setItem("plcData",JSON.stringify(data) );
          this.$router.push({
            path: "/places/" + slug,
          });
        }
        else{
          if (localStorage.getItem("plcData")) {
        localStorage.removeItem('plcData');
      }
      this.$emit('blogIdSent', slug)
      this.$router.push({
        path: "/places/" + slug,
      });
        }
    },

    clickPlaces(slug){
      if (localStorage.getItem("plcData")) {
        localStorage.removeItem('plcData');
      }
      this.$emit('blogIdSent', slug)
      this.$router.push({
        path: "/places/" + slug,
      });
    }
  }
}

